import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Ledgers from './pages/Ledgers';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Trade from './pages/Trade';
import TradeEntry from './pages/TradeEntry';
import Payments from './pages/Payments';
import Expenses from './pages/Expenses';
import Banks from './pages/Banks';
import BankStatements from './pages/BankStatements';
import Vehicles from './pages/Vehicles';
import Maintenance from './pages/Maintenance';
import Fuel from './pages/Fuel';
import Trips from './pages/Trips';
import Accounts from './pages/Accounts';
import Journal from './pages/Journal';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Company from './pages/Company';

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Protected><Home /></Protected>} />
        <Route path="/dashboard-reports" element={<Protected><Dashboard /></Protected>} />
        <Route path="/ledgers" element={<Protected><Ledgers /></Protected>} />
        <Route path="/products" element={<Protected><Products /></Protected>} />
        <Route path="/categories" element={<Protected><Categories /></Protected>} />
        <Route path="/trade-entry" element={<Protected><TradeEntry /></Protected>} />
        <Route path="/trade" element={<Protected><Trade /></Protected>} />
        <Route path="/purchases" element={<Protected><Navigate to="/trade" replace /></Protected>} />
        <Route path="/sales" element={<Protected><Navigate to="/trade" replace /></Protected>} />
        <Route path="/payments" element={<Protected><Payments /></Protected>} />
        <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
        <Route path="/banks" element={<Protected><Banks /></Protected>} />
        <Route path="/bank-statements" element={<Protected><BankStatements /></Protected>} />
        <Route path="/vehicles" element={<Protected><Vehicles /></Protected>} />
        <Route path="/maintenance" element={<Protected><Maintenance /></Protected>} />
        <Route path="/fuel" element={<Protected><Fuel /></Protected>} />
        <Route path="/trips" element={<Protected><Trips /></Protected>} />
        <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
        <Route path="/journal" element={<Protected><Journal /></Protected>} />
        <Route path="/reports" element={<Protected><Reports /></Protected>} />
        <Route path="/users" element={<Protected><Users /></Protected>} />
        <Route path="/company" element={<Protected><Company /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" />
      <Router />
    </AuthProvider>
  );
}
